import React from 'react'
import BodyColumnLayout from '../../../palletLocation/Layouts/BodyColumnLayout'
import OrderlikeLayout from '../../../../../../generic/Layouts/OrderlikeLayout'
import { useProductLocation } from '../context/ProductLocationProvider'
import ScanPalletCard from './ScanPalletCard'
import ImageComponentHead from '../../../../../../generic/imageComponents/ImageComponentHead'
import Image from '../../../../../../generic/assets/warhouseWork.webp'
import LocationCard from './LocationCard'
import ControlButton from '../../../../../../generic/buttons/ControlButton'
type Props = {}

const ProductLocationMain = (props: Props) => {
  const {
    openModal,
    scannedPallet,
    scannedLocation,
    isOpenModal,
    closeModal,
    barecode,
    setBarecode,
    locationCode,
    setLocationCode,
    handleScanPallet,
    handleScanLocation,
    clearScannedDataPallet,
    clearScannedDataLocation,
    handleBoundPalletToLocation,
  } = useProductLocation()
  return (
    <OrderlikeLayout
        label='איתור למשטח'
      >
        <BodyColumnLayout
        
        >
          <ScanPalletCard
            palletData={scannedPallet}
            handleScanPallet={handleScanPallet}
            clearScannedDataPallet={clearScannedDataPallet}
            input={barecode}
            setInput={setBarecode}
          />
          {
            !scannedPallet && (
              <ImageComponentHead
                img={Image}
                large={true}
              />
            )
          }
          {
            scannedPallet && (
              <LocationCard
                locationData={scannedLocation}
                handleScanLocation={handleScanLocation}
                clearScannedDataLocation={clearScannedDataLocation}
                input={locationCode}
                setInput={setLocationCode}
              />
            )
          }
        </BodyColumnLayout>
          {
          scannedPallet && scannedLocation && (
            <ControlButton
              lable=' עדכן איתור'
              handleClick={handleBoundPalletToLocation}
            />
          )
          }
      </OrderlikeLayout>
  )
}

export default ProductLocationMain